import React, { useEffect, useState, useRef } from "react";
import bottiglia from "../../assets/Foto per transizione/P1088470.jpg";

const Sectionhome1 = () => {
  useEffect(() => {
    const elements = document.querySelectorAll(".moving-paragraph"); // Seleziona tutti gli elementi con la classe moving-paragraph

    // Verifica che ci siano elementi da osservare
    if (elements.length > 0) {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add("visible");
            } /*  else {
                  entry.target.classList.remove("visible");
                } */
          });
        },
        {
          threshold: 0.3, // La visibilità minima dell'elemento per attivare la transizione
        }
      );

      // Osserva ogni elemento con la classe 'moving-paragraph'
      elements.forEach((element) => observer.observe(element));

      // Cleanup dell'observer al momento dello smontaggio
      return () => observer.disconnect();
    }
  }, []); // Solo al primo render
  return (
    <div
      id="linee"
      className="bg-[#7f8473] flex gap-x-[20em] flex-col md:flex-row items-center justify-center min-h-[60vh] p-8 text-white"
    >
      {/* Left Section - Text */}
      <div className="md:w-1/4 text-center md:text-center flex flex-col items-center md:items-center moving-paragraph">
        <h1 className="text-4xl md:text-5xl font-bold text-white">LINEE</h1>
        <h2 className="italic text-lg md:text-xl mt-2 font-bold">Asproarota</h2>
        <p className="mt-4 text-lg md:text-xl max-w-lg md:max-w-xl">
          Asproarota: straordinariamente autentica, questa linea racchiude la
          storia dei nostri valori. "Aspro" come il nostro territorio, "Arota"
          come il toponimo dei luoghi d'origine, quest'olio è identità.
        </p>
      </div>

      {/* Right Section - Single Image */}
      <div className="flex justify-center mt-6 md:mt-0 moving-paragraph">
        <div className="w-3/4 flex justify-center">
          {" "}
          {/* Aggiunto flex + justify-center */}
          <img
            src={bottiglia}
            alt="Piatto raffinato"
            className="w-[70vh] h-auto rounded-lg mx-auto"
          />
        </div>
      </div>
    </div>
  );
};

export default Sectionhome1;
